<template>
  <div class="collapsible-filter">
    <!-- 标题栏 -->
    <div class="title" @click="toggleCollapse">
      {{ title }}
      <img
        class="toggle-icon"
        :class="{ collapsed: isCollapsed }"
        style="width: 24px; height: 24px"
        src="@/assets/down@2x.png"
        alt=""
      />
    </div>
    <!-- 可折叠内容区域 -->
    <transition name="collapse">
      <div v-show="!isCollapsed" class="filter-content">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

// 定义 Props
interface Props {
  title?: string;
  defaultCollapsed?: boolean;
  modelValue?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  title: "筛选条件",
  defaultCollapsed: true,
  modelValue: undefined,
});

// 定义 Emits
const emit = defineEmits<{
  "update:modelValue": [value: boolean];
  change: [value: boolean];
}>();

// 内部折叠状态
const isCollapsed = ref(props.defaultCollapsed);

// 切换折叠状态
const toggleCollapse = () => {
  isCollapsed.value = !isCollapsed.value;
  emit("update:modelValue", isCollapsed.value);
  emit("change", isCollapsed.value);
};

// 监听外部 v-model 变化
watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal !== undefined && newVal !== isCollapsed.value) {
      isCollapsed.value = newVal;
    }
  },
);
</script>

<style scoped lang="less">
.collapsible-filter {
  width: 100%;
}

.title {
  width: 100%;
  height: 60px;
  // background: #FFFFFF;
  border-radius: 15px;
  display: flex;
  align-items: center;
  gap: 30px;
  // justify-content: space-between;
  // padding: 0 30px;
  box-sizing: border-box;
  font-family:
    PingFang HK,
    PingFang HK;
  font-weight: 600;
  font-size: 18px;
  color: #0a1c46;
  cursor: pointer;
  user-select: none;
  transition: all 0.3s ease;

  &:hover {
    // background: #f5f7fa;
  }

  .toggle-icon {
    transition: transform 0.3s ease;

    &.collapsed {
      transform: rotate(-90deg);
    }
  }
}

.filter-content {
  margin-top: 20px;
}

// 折叠动画
.collapse-enter-active,
.collapse-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}

.collapse-enter-from,
.collapse-leave-to {
  opacity: 0;
  max-height: 0;
  margin-top: 0;
}

.collapse-enter-to,
.collapse-leave-from {
  opacity: 1;
  max-height: 1000px;
  margin-top: 20px;
}
</style>
